module.exports = __webpack_public_path__ + "img/xiangji-2@2x.eb8a1e5e.png";